import React, { useState, useEffect, useRef } from 'react';
import { Button, TextField, makeStyles, Typography, Box } from '@material-ui/core';
import usePermissions from 'hooks/permissions-hooks';
import SearchIcon from '@material-ui/icons/Search';
import { FaBarcode } from 'react-icons/fa';
import SerialNumberDetails from '../components/business/serial-numbers/SerialNumberDetails';
import getTheme from '../theme/theme';

const useStyles = makeStyles(() => {
  return {
    customTextField: {
      '& .MuiInputBase-input': {
        fontSize: '20px',
      },
    },

    paddedButton: {
      marginLeft: '30px',
      minHeight: '60px',
      fontSize: '20px',
    },

  };
});

function SerialDashboard() {
  const classes = useStyles();

  const [ serialNumber, setSerialNumber ] = useState('');
  const [ searchSerial, setSearchSerial ] = useState('');
  const [ error, setError ] = useState(false);
  const [ helperText, setHelperText ] = useState('');

  const { role } = usePermissions();
  const inputRef = useRef(null);

  const handleClick = () => {
    // validation
    if (searchSerial.trim().length < 8) {
      setError(true);
      setHelperText('Το SerialNumber πρέπει να έχει τουλάχιστον 8 χαρακτήρες');
    } else if (searchSerial.trim().length > 20) {
      setError(true);
      setHelperText('Το SerialNumber δεν μπορεί να έχει περισσότερους από 20 χαρακτήρες');
    } else {
      // default action
      setSerialNumber(searchSerial.trim());
    }
  };

  // Clear Buttons Action
  const clearAll = () => {
    setSearchSerial('');
    setSerialNumber('');
    setError(false);
    setHelperText('');
  };

  // clear validation error to retry search
  const clearError = () => {
    if (error) {
      setError(false);
      setHelperText('');
    }
  };

  // Start search with Enter key
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  // Initial focus at TextField
  useEffect(() => {
    inputRef.current.focus();
  },
  []);

  // clear all after role changed
  useEffect(() => {
    setSerialNumber('');
    setSearchSerial('');
  }, [ role ]);

  return (
    <>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <FaBarcode
          style={ { color: 'secondary' } }
          size={ 36 }
        />
        <Box p={ 2 }>
          <Typography variant='h5'>
            Serial Number Dashboard
          </Typography>
        </Box>
      </div>
      <TextField
        className={ classes.customTextField }
        inputRef={ inputRef }
        id='search-bar'
        color='secondary'
        size='medium'
        error={ error }
        helperText={ helperText }
        value={ searchSerial }
        onFocus={ clearError }
        onChange={ (e) => { setSearchSerial(e.target.value); } }
        onKeyPress={ (e) => { handleKeyPress(e); } }
        label='Enter Kit Serial Number'
        variant='outlined'
        defaultValue='20px Text'
      />
      <Button
        className={ classes.paddedButton }
        variant='outlined'
        size='large'
        color='secondary'
        onClick={ () => { handleClick(); } }
      >
        <SearchIcon />
        SEARCH
      </Button>
      { searchSerial.length > 0
      && (
        <Button
          className={ classes.paddedButton }
          variant='outlined'
          size='large'
          color='secondary'
          onClick={ () => { clearAll(); } }
        >
          CLEAR
        </Button>
      )}
      {serialNumber.length > 0 && <SerialNumberDetails serialNumber={ serialNumber } />}
    </>
  );
}

export default SerialDashboard;
